import SiteFooter from '@/components/feature/SiteFooter';
import SiteNavbar from '@/components/feature/SiteNavbar';
import {
  SustainabilityCta,
  SustainabilityHero,
  SustainabilityIntro,
  SustainabilityPillars,
} from './components/Sections';

export default function Sustainability() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <SustainabilityHero />
        <SustainabilityIntro />
        <SustainabilityPillars />
        <SustainabilityCta />
      </main>
      <SiteFooter />
    </div>
  );
}